import { I18n } from '../../utils/i18n';
import moment from 'moment-timezone';
import apiClient from '../../api/index';
import {
  GetCurrentUserDataResponse,
  GetUserCompaniesResponse,
  IUserService
} from './contracts/user.service';
import { IUserCompanyDetails } from 'types/user';
import { getDefaultLocale } from '@clean-code/utils/i18n';

export const UserService: IUserService = {
  async getCurrentUserData(): Promise<GetCurrentUserDataResponse> {
    const response = await apiClient.request('GET', '/identity/me');
    moment.tz.setDefault(response.data.timezone); // TODO: coolgsus: look for a better place to put this;
    I18n.setLocale(localStorage.getItem('i18n-locale') || getDefaultLocale());
    return response.data as GetCurrentUserDataResponse;
  },
  async getUserCompanies(): Promise<GetUserCompaniesResponse> {
    const response = await apiClient.request('GET', '/identities/companies');
    return response as GetUserCompaniesResponse;
  },
  async getAvailableCompanies(): Promise<IUserCompanyDetails[]> {
    const response = await apiClient.request('GET', '/identities/corporations');
    return response as IUserCompanyDetails[];
  }
};
